
            import tailwindConfig from "@/../tailwind.config.ts";
            import "https://esm.sh/tailwindcss-cdn@3";
            tailwind.config = tailwindConfig;
          